"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    tooltipTitle: _propTypes.string,
    tooltipContent: _propTypes.string,
    iconLink: _propTypes.string,
    iconData: (0, _propTypes.shape)({
      color: _propTypes.string,
      fontsize: _propTypes.string,
      type: _propTypes.string
    }),
    tooltipData: (0, _propTypes.shape)({
      width: _propTypes.number,
      zIndex: _propTypes.number
    })
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    tooltipContent: 'Find Out More',
    iconData: _constant2.DEFAULT_ICON,
    tooltipData: _constant2.DEFAULT_TOOLTIP_DATA
  }
};
exports.default = _default;